<template>
  <div>
    <div
      ref="fotoPortadaRef"
      class="fotoportada-container"
    >
      <div class="overlay">
        <!-- MIS XV ARRIBA IZQUIERDA -->
        <div class="mis-xv-wrapper-fixed">
          <img
            ref="coronaRef"
            src="@/assets/corona.png"
            alt="Ornamento"
            class="ornamento-img"
          >
          <div
            ref="misXvTopRef"
            class="mis-xv-top glowing"
          >
            MIS XV
          </div>
        </div>

        <!-- Nombres y Fecha (Adaptables) -->
        <div
          ref="nombreRef"
          class="centered-text"
        >
          BRYANNA ISABEL<br> 
          <span class="apellido">Carpintero Casas</span>

          <div
            ref="fechaRef"
            class="fecha-evento"
          >
            <span class="fecha-dia">16</span>
            <span class="fecha-separador">/</span>
            <span class="fecha-mes">OCT</span>
            <span class="fecha-separador">/</span>
            <span class="fecha-anio">2026</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'NavbarComponent',
  setup() {
    const fotoPortadaRef = ref(null)
    const nombreRef = ref(null)
    const fechaRef = ref(null)
    const misXvTopRef = ref(null)
    const coronaRef = ref(null)

    onMounted(() => {
      /* ANIMACIÓN FONDO PRINCIPAL */
      gsap.from(fotoPortadaRef.value, {
        opacity: 0,
        y: 60,
        duration: 1.8,
        ease: 'power4.out'
      })

      const entradaPrincipal = gsap.timeline({ delay: 0.6 })

      /* ANIMACIÓN CORONA */
      entradaPrincipal.fromTo(
        coronaRef.value,
        {
          opacity: 0,
          y: -80,
          scale: 1.8,
          filter: 'blur(8px)'
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          filter: 'blur(0px)',
          duration: 1.5,
          ease: 'back.out(1.2)'
        },
        0
      )

      /* ANIMACIÓN TEXTO "MIS XV" */
      entradaPrincipal.from(
        misXvTopRef.value,
        {
          opacity: 0,
          y: 20,
          duration: 1.2,
          ease: 'power3.out'
        },
        0.3
      )

      /* ANIMACIÓN NOMBRE */
      entradaPrincipal.fromTo(
        nombreRef.value,
        {
          opacity: 0,
          y: -30,
          scale: 0.95
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 1.6,
          ease: 'power4.out'
        },
        0.2
      )

      /* ANIMACIÓN ESCALONADA DE LA FECHA */
      gsap.to(fechaRef.value.children, {
        opacity: 1,
        y: 0,
        duration: 1.2,
        stagger: 0.15,
        ease: 'back.out(1.5)',
        delay: 1.8
      })

      /* EFECTO FLOTANTE CONTINUO DE LA CORONA */
      gsap.to(coronaRef.value, {
        y: '-=6',
        duration: 2.5,
        repeat: -1,
        yoyo: true,
        ease: 'power1.inOut',
        delay: 2.2
      })
    })

    return {
      fotoPortadaRef,
      nombreRef,
      fechaRef,
      misXvTopRef,
      coronaRef
    }
  }
}
</script>

<style scoped>
.fotoportada-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  margin-top: -105px;
  background-image: 
    linear-gradient(to bottom, rgba(255,255,255,0), rgba(0, 0, 0, 0.2)), 
    url('@/assets/1000360946_11zon.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  z-index: 1;
}

.overlay {
  position: absolute;
  top: 45px;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 140px; /* Se reduce dinámicamente en móviles mediante media query abajo */
  color: white;
  z-index: 2;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.65) 0%,
    rgba(0, 0, 0, 0.2) 40%,
    rgba(0, 0, 0, 0) 100%
  );
}

/* MIS XV */
.mis-xv-wrapper-fixed {
  position: absolute;
  top: 25px;
  left: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 3;
}

.ornamento-img {
  width: 40px;
  opacity: 0;
  filter: brightness(0) invert(1);
  margin-bottom: 4px;
}

.mis-xv-top {
  font-family: 'file';
  font-size: clamp(16px, 4vw, 20px); /* 📱 Escala fluida según tamaño de pantalla */
  letter-spacing: 1px;
  color: white;
}

.apellido {
  font-family: 'british', cursive;
  display: inline-block;
  margin-top: 5px;
}

.centered-text {
  text-align: center;
  font-family: 'cursivatitulo', serif;
  /* 📱 clamp(TamañoMínimo, TamañoDeseadoPantalla, TamañoMáximo) */
  font-size: clamp(26px, 7.5vw, 39px); 
  margin-top: 60px;
  line-height: 1.2;
  color: white;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  width: 90%; /* Evita que el texto toque los bordes del celular */
  max-width: 600px;
}

.fecha-evento {
  color: white;
  font-size: clamp(14px, 4vw, 18px); /* 📱 Fecha fluida */
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 20px;
}

.fecha-evento span {
  opacity: 0;
  transform: translateY(15px);
}

/* ==================== 📱 AJUSTES CRÍTICOS PARA MÓVILES ==================== */
@media (max-width: 480px) {
  .overlay {
    padding-top: 110px; /* Reduce el espacio muerto superior en pantallas chicas */
  }
  
  .mis-xv-wrapper-fixed {
    top: 15px;
    left: 15px; /* Acerca "MIS XV" a la esquina superior izquierda */
  }

  .ornamento-img {
    width: 32px; /* Corona un poco más pequeña en celulares compactos */
  }

  .centered-text {
    margin-top: 35px; /* Reduce la separación entre "MIS XV" y los nombres principales */
  }
  
  .fecha-evento {
    margin-top: 15px; /* Compacta el espacio vertical de la fecha */
  }
}
</style>